var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.name,_vm._b({tag:"component",staticClass:"icon-svg",attrs:{"fill":_vm.fill || _vm.color,"stroke":_vm.stroke || 'transparent',"width":_vm.size}},'component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }